import { ICreateAndUpdateMunicipality } from "../../../types/municipality.interface";
import customAxios from "../../customAxios";
import { CREATE_MUNICIPALITY } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const createMunicipality = async (props: ICreateAndUpdateMunicipality) => {
  const body = {
    userName: props?.userName,
    password: props?.password,
    name: props?.name,
    cities: props?.cities,
  };

  try {
    return (await customAxios.post(CREATE_MUNICIPALITY, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_MUNICIPALITY: error });
    return false;
  }
};

export default createMunicipality;
